import { ContentObserver } from '@angular/cdk/observers';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent  {
  constructor() { }
  @Output() sendDataToParent: any = new EventEmitter();
  @Input({ required: true }) datasource: any
  @Input({ required: true }) total_data_length: any;
  @Input({ required: true }) pageSize = 0;
  @Input({ required: true }) currentPage = 0;




  pageSizeOptions = [10, 20, 50, 100];
  maxSize = 2;

  firstLastButtons = true;
  nextPreviousButtons = true;
  small = false;

  totalPages: any



  data: any = 0
  ngOnChanges() {
    this.data = this.datasource?.data?.length ?? 0;
    this.totalPages = new Array(Math.ceil(this.total_data_length / this.pageSize));
  }


  dataToParent(pageSize: any, currentPage: any) {
    this.sendDataToParent.emit({ pageSize, currentPage });
  }

  onPageSizeChange(event: any) {
    if (this.totalPages.length <= this.currentPage) {
      this.currentPage = 1
    }
    this.pageSize = event.value
    this.dataToParent(this.pageSize, this.currentPage)
    this.totalPages = new Array(Math.ceil(this.total_data_length / this.pageSize));
  }

  selectPageNumber(pageNumber: number) {
    this.currentPage = pageNumber;
    this.dataToParent(this.pageSize, this.currentPage)
  }

  next() {
    const nextPage = this.currentPage + 1;
    nextPage <= this.totalPages.length && this.selectPageNumber(nextPage);
  }

  previous() {
    const previousPage = this.currentPage - 1;
    previousPage >= 1 && this.selectPageNumber(previousPage);
  }
}
